// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.client

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.client.DocumentPreconsentSetting
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.wallet.client.DocumentPreconsentSetting.AlwaysRequireConsent
import org.multipaz.wallet.client.DocumentPreconsentSetting.NeverRequireConsent
import org.multipaz.wallet.client.DocumentPreconsentSetting.ReaderIdentityBased
import org.multipaz.wallet.client.DocumentPreconsentSetting.RequestComplexityBased

fun DocumentPreconsentSetting.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "yJOFqy7a7LRbHos2HXvWmcO6ixsACAaZKR8ahUqAEyc")
val DocumentPreconsentSetting_cborSchemaId = ByteString(-56, -109, -123, -85, 46, -38, -20, -76, 91, 30, -117, 54, 29, 123, -42, -103, -61, -70, -117, 27, 0, 8, 6, -103, 41, 31, 26, -123, 74, -128, 19, 39)

fun DocumentPreconsentSetting.Companion.fromCbor(data: ByteArray): DocumentPreconsentSetting {
    return DocumentPreconsentSetting.fromDataItem(Cbor.decode(data))
}

val DocumentPreconsentSetting.Companion.cborSchemaId: ByteString
    get() = DocumentPreconsentSetting_cborSchemaId

fun DocumentPreconsentSetting.toDataItem(): DataItem {
    return when (this) {
        is AlwaysRequireConsent -> (this as AlwaysRequireConsent).toDataItem()
        is NeverRequireConsent -> (this as NeverRequireConsent).toDataItem()
        is ReaderIdentityBased -> (this as ReaderIdentityBased).toDataItem()
        is RequestComplexityBased -> (this as RequestComplexityBased).toDataItem()
    }
}

fun DocumentPreconsentSetting.Companion.fromDataItem(dataItem: DataItem): DocumentPreconsentSetting {
    val type = dataItem["type"].asTstr
    return when (type) {
        "AlwaysRequireConsent" -> AlwaysRequireConsent_fromDataItem(dataItem)
        "NeverRequireConsent" -> NeverRequireConsent_fromDataItem(dataItem)
        "ReaderIdentityBased" -> ReaderIdentityBased_fromDataItem(dataItem)
        "RequestComplexityBased" -> RequestComplexityBased_fromDataItem(dataItem)
        else -> throw IllegalArgumentException("wrong type: $type")
    }
}
